import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { Cell, Column, Table } from 'fixed-data-table-2';
import TextCell from '../../../components/TextCell/TextCell';
import { DateType } from '../../../containers/UIhelper/UIDateFormater';
import ReactPaginate from 'react-paginate';

const _ = require('lodash');

const PRESSURE_CONVERSION = {
  meter: { factor: 1, label: 'Meter' },
  bar: { factor: 0.0980665, label: 'Bar' },
  kpa: { factor: 9.80665, label: 'kPa' },
  psi: { factor: 1.42233, label: 'PSI' },
};

require('../SensorInfo/SensorInfo.scss');

class PressureSensorSamplesTab extends React.Component {
  constructor(props) {
    super(props);

    this.handlePageClick = this.handlePageClick.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.rowClassNameGetter = this.rowClassNameGetter.bind(this);

    this.state = {
      rowForScrolling: null,
    };
  }

  onRowClick(event, rowIndex) {
    this.props.selectSensorSample(this.props.sensorsSamples[rowIndex]);
  }

  rowClassNameGetter(rowIndex) {
    const { selectedSensorSample, sensorsSamples } = this.props;
    return selectedSensorSample !== null &&
      sensorsSamples[rowIndex] &&
      selectedSensorSample.sample_date === sensorsSamples[rowIndex].sample_date
      ? 'active-row'
      : '';
  }

  handlePageClick(event) {
    this.setState(
      {
        rowForScrolling: 0,
      },
      () => {
        this.setState({ rowForScrolling: null });
      }
    );
    this.props.onPageIndexChange(event.selected, 'SensorSamplesTab');
  }

  render() {
    const {
      sensorsSamples,
      totalNoiseSamplesCount,
      noiseSamplesRequestedCount,
      uiInfo,
      timeZone,
      projectTimeZone,
      pressureUnit,
    } = this.props;

    const pWidth = 0.395 * (uiInfo.pageWidth - 10);
    const pHeight = 0.494 * uiInfo.pageHeight - 8;

    const conversion = PRESSURE_CONVERSION[pressureUnit] || PRESSURE_CONVERSION.meter;
    const rawData = sensorsSamples !== null && !_.isEmpty(sensorsSamples) ? sensorsSamples : [];
    const data = rawData.map((sample) => ({
      ...sample,
      trend_avg_m: sample.trend_avg_m != null ? (parseFloat(sample.trend_avg_m) * conversion.factor).toFixed(2) : sample.trend_avg_m,
      trend_max_m: sample.trend_max_m != null ? (parseFloat(sample.trend_max_m) * conversion.factor).toFixed(2) : sample.trend_max_m,
      trend_min_m: sample.trend_min_m != null ? (parseFloat(sample.trend_min_m) * conversion.factor).toFixed(2) : sample.trend_min_m,
    }));

    return (
      <div>
        <Table
          rowsCount={data.length}
          width={pWidth}
          scrollToRow={this.state.rowForScrolling}
          onRowClick={this.onRowClick}
          rowClassNameGetter={this.rowClassNameGetter}
          maxHeight={pHeight - 117}
          headerHeight={46}
          rowHeight={30}
        >
          <Column
            columnKey='sample_date'
            header={<Cell>{this.context.t('sample_date')}</Cell>}
            cell={
              <TextCell
                data={data}
                field='sample_date'
                dateType={DateType.DATE}
                projectTimezone={projectTimeZone}
              />
            }
            width={120}
            flexGrow={1}
          />
          <Column
            columnKey='trend_avg_m'
            header={<Cell>{`${this.context.t('trend_avg')} (${conversion.label})`}</Cell>}
            cell={<TextCell data={data} field='trend_avg_m' />}
            width={100}
            flexGrow={1}
            align='center'
          />
          <Column
            columnKey='trend_max_m'
            header={<Cell>{`${this.context.t('trend_max')} (${conversion.label})`}</Cell>}
            cell={<TextCell data={data} field='trend_max_m' />}
            width={100}
            flexGrow={1}
            align='center'
          />
          <Column
            columnKey='trend_min_m'
            header={<Cell>{`${this.context.t('trend_min')} (${conversion.label})`}</Cell>}
            cell={<TextCell data={data} field='trend_min_m' />}
            width={100}
            flexGrow={1}
            align='center'
          />
        </Table>

        <div className='center'>
          <ReactPaginate
            previousLabel={this.context.t('prev')}
            nextLabel={this.context.t('next')}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={Math.ceil(
              totalNoiseSamplesCount / noiseSamplesRequestedCount
            ) || 1}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={this.handlePageClick}
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
            forcePage={this.props.currentPage || 0}
          />
        </div>
      </div>
    );
  }
}

PressureSensorSamplesTab.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  pressureUnit: state.local.pressureUnit || 'meter',
}))(PressureSensorSamplesTab);
